<script setup>
    import { toRefs, ref } from 'vue'
    import TermsOfService from './TermsOfService.vue'

const props = defineProps({
isHome: Boolean
})
const {isHome} = toRefs(props)

const legalDialog = ref(false)
const tosRef = ref(null)

const openTOS = () => {
    if (tosRef.value) {
        tosRef.value.tosDialog = true
    }
}

</script>

<template>
<div v-if="isHome" style="background: #34275e;">
    <v-footer class="text-center d-flex flex-column" :home="isHome" style="margin-left: 24px;margin-right: 24px;margin-bottom: 24px;border-radius: 6px;margin-top: 24px;">
      <img src="https://cdn.nightriderz.world/images/website/logo/NRZ_Wide.svg" height="30"><br>
      <div class="pt-0">© NIGHTRIDERZ {{ new Date().getFullYear() }}. All Rights Reserved.<br>
        This project is not affiliated with <b>Electronic Arts</b> or the <b>Need for Speed™</b> brand in any way, shape or form. <b>Need for Speed</b> is a trademark of <b>Electronic Arts</b>.
      </div>
      <v-btn variant="text" class="legal-btn" @click="legalDialog = true">Legal Notices</v-btn>
    </v-footer>
</div>
<div v-else>
    <v-footer class="text-center d-flex flex-column" :home="isHome" style="margin-left: 24px;margin-right: 24px;margin-bottom: 24px;border-radius: 6px;margin-top: 24px;">
      <img src="https://cdn.nightriderz.world/images/website/logo/NRZ_Wide.svg" height="30"><br>
      <div class="pt-0">© NIGHTRIDERZ {{ new Date().getFullYear() }}. All Rights Reserved.<br>
        This project is not affiliated with <b>Electronic Arts</b> or the <b>Need for Speed™</b> brand in any way, shape or form. <b>Need for Speed</b> is a trademark of <b>Electronic Arts</b>.
      </div>
      <v-btn variant="text" class="legal-btn" @click="legalDialog = true">Legal Notices</v-btn>
    </v-footer>
</div>

<!-- Legal Notices Dialog -->
<v-dialog v-model="legalDialog" max-width="900px" scrollable>
  <v-card class="legal-card">    <div class="legal-header-bg" style="margin-bottom: 75px;">
      <div class="legal-header d-flex align-center px-4">
        <div class="text-h4 font-weight-bold text-white">Legal Notices</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="legalDialog = false" variant="text" class="close-btn">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </div>
    
    <v-card-text class="legal-content">
      <div class="legal-intro">
        <div class="intro-icon-container">
          <v-icon size="x-large" color="primary" class="intro-icon">mdi-scale-balance</v-icon>
        </div>
        <p class="text-body-1">In accordance with Article 6 of French Law No. 2004-575 of June 21, 2004, for confidence in the digital economy, users of the site are informed of the identity of the various parties involved in its creation and monitoring.</p>
      </div>

      <v-row>
        <v-col cols="12" sm="6">
          <v-card variant="outlined" class="legal-section-card mb-4">
            <v-card-item>
              <template v-slot:prepend>
                <div class="icon-circle">
                  <v-icon color="white">mdi-account-tie</v-icon>
                </div>
              </template>
              <v-card-title>Site Publisher</v-card-title>
            </v-card-item>
            <v-card-text>
              <p class="mb-2">
                <strong>Steven Milleville</strong><br>
                Micro-entrepreneur<br>
                SIREN: <strong>944240530</strong><br>
                Professional address: 63B rue Marceau, 62790 Leforest, France<br>
                Email: contact@nightriderz.world
              </p>
              <p class="text-caption font-italic opacity-medium">VAT not applicable, Article 293 B of the CGI</p>
            </v-card-text>
          </v-card>
        </v-col>
        
        <v-col cols="12" sm="6">
          <v-card variant="outlined" class="legal-section-card mb-4">
            <v-card-item>
              <template v-slot:prepend>
                <div class="icon-circle">
                  <v-icon color="white">mdi-server</v-icon>
                </div>
              </template>
              <v-card-title>Website Hosting</v-card-title>
            </v-card-item>
            <v-card-text>
              <p>
                Host: HETZNER<br>
                Address: Hetzner Online GmbH, Industriestr. 25, 91710 Gunzenhausen, Germany<br>
                Phone: +49 (0)9831 505-0*
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
        
      <v-row>
        <v-col cols="12">
          <v-card variant="outlined" class="legal-section-card mb-4">
            <v-card-item>
              <template v-slot:prepend>
                <div class="icon-circle">
                  <v-icon color="white">mdi-gavel</v-icon>
                </div>
              </template>
              <v-card-title>Terms of Use</v-card-title>
            </v-card-item>
            <v-card-text>
              <p>The use of the site implies full and complete acceptance of the general conditions of use which may be modified at any time.</p>
              <v-btn color="primary" variant="tonal" class="mt-4" @click="openTOS">View Terms of Service</v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      
      <v-row>
        <v-col cols="12" sm="6">
          <v-card variant="outlined" class="legal-section-card mb-4">
            <v-card-item>
              <template v-slot:prepend>
                <div class="icon-circle">
                  <v-icon color="white">mdi-shield-account</v-icon>
                </div>
              </template>
              <v-card-title>Personal Data</v-card-title>
            </v-card-item>
            <v-card-text>
              <p>No personal information is collected without the user's knowledge. Any data that may be transmitted (via contact form or purchase) is neither resold nor used for commercial purposes without consent.</p>
            </v-card-text>
          </v-card>
        </v-col>
        
        <v-col cols="12" sm="6">
          <v-card variant="outlined" class="legal-section-card mb-4">
            <v-card-item>
              <template v-slot:prepend>
                <div class="icon-circle">
                  <v-icon color="white">mdi-copyright</v-icon>
                </div>
              </template>
              <v-card-title>Intellectual Property</v-card-title>
            </v-card-item>
            <v-card-text>
              <p>The content of this site (texts, images, codes) is the property of its author and may not be copied without authorization.</p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      
      <v-card variant="outlined" class="legal-disclaimer mt-4">
        <v-card-item>
          <template v-slot:prepend>
            <div class="icon-circle warning">
              <v-icon color="white">mdi-alert-circle</v-icon>
            </div>
          </template>
          <v-card-title>Disclaimer</v-card-title>
        </v-card-item>
        <v-card-text>
          <p>This project is <strong>not affiliated with Electronic Arts</strong>. <em>Need for Speed World</em> is a registered trademark belonging to EA. This site offers an independent non-profit community service or with support options.</p>
        </v-card-text>
      </v-card>
    </v-card-text>
    
    <v-divider></v-divider>
    
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" variant="tonal" @click="legalDialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<TermsOfService ref="tosRef" />
</template>

<style scoped>
footer {
    background: var(--primary-color);
    padding-top: 40px;
    padding-bottom: 40px;
    margin-top: 40px;
    position: relative;
}

[home='true'] {
    margin-top: 0;
}

button {
    margin: 20px 10px;
}

.legal-btn {
    margin-top: 10px;
    font-size: 0.85rem;
    text-transform: none;
    opacity: 0;
    position: absolute;
    bottom: 10px;
    right: 10px;
    transition: opacity 0.3s ease-in-out;
}

footer:hover .legal-btn {
    opacity: 0.8;
}

footer:hover .legal-btn:hover {
    opacity: 1;
}

.close-btn {
    color: white !important;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    backdrop-filter: blur(8px);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.close-btn:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: rotate(90deg);
}

.legal-card {
    border-radius: 16px !important;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5) !important;
    background-color: #1a1f2a !important;
}

.legal-header-bg {
    background: linear-gradient(135deg, #6b46c1 0%, #4834d4 100%);
    padding: 2rem 1.5rem 6rem;
    position: relative;
    overflow: hidden;
}

.legal-header-bg::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    opacity: 0.1;
    animation: moveBackground 30s linear infinite;
}

@keyframes moveBackground {
    from { background-position: 0 0; }
    to { background-position: 100% 100%; }
}

.legal-header {
    position: relative;
    z-index: 2;
}

.legal-content {
    padding: 0 1.5rem 1.5rem;
    margin-top: -4rem;
    position: relative;
    z-index: 3;
}

.legal-intro {
    background: rgba(255, 255, 255, 0.03);
    border-radius: 12px;
    padding: 2rem;
    margin-bottom: 2rem;
    text-align: center;
    border: 1px solid rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(10px);
}

.intro-icon-container {
    width: 80px;
    height: 80px;
    margin: 0 auto 1.5rem;
    background: linear-gradient(135deg, rgba(107, 70, 193, 0.2), rgba(72, 52, 212, 0.2));
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.intro-icon {
    font-size: 2rem;
    background: linear-gradient(135deg, #6b46c1, #4834d4);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    filter: drop-shadow(0 0 20px rgba(107, 70, 193, 0.5));
}

.legal-section-card {
    background: rgba(255, 255, 255, 0.02) !important;
    border: 1px solid rgba(255, 255, 255, 0.05) !important;
    border-radius: 12px !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    height: 100%;
    backdrop-filter: blur(10px);
}

.legal-section-card:hover {
    transform: translateY(-4px);
    border-color: rgba(107, 70, 193, 0.5) !important;
    box-shadow: 0 12px 24px -8px rgba(107, 70, 193, 0.3) !important;
}

.icon-circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: linear-gradient(135deg, #6b46c1, #4834d4);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(107, 70, 193, 0.3);
}

.icon-circle.warning {
    background: linear-gradient(135deg, #eab308, #d97706);
    box-shadow: 0 4px 12px rgba(234, 179, 8, 0.3);
}

.legal-disclaimer {
    background: rgba(234, 179, 8, 0.05) !important;
    border: 1px solid rgba(234, 179, 8, 0.2) !important;
    border-radius: 12px !important;
}

.v-card-title {
    font-size: 1.25rem !important;
    font-weight: 600 !important;
    color: rgba(255, 255, 255, 0.95) !important;
}

.v-card-text {
    color: rgba(255, 255, 255, 0.7) !important;
    line-height: 1.6;
}

strong {
    color: rgba(255, 255, 255, 0.95);
    font-weight: 600;
}

.opacity-medium {
    opacity: 0.6;
}

/* Animations */
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.legal-section-card {
    animation: fadeInUp 0.6s ease-out;
    animation-fill-mode: both;
}

.legal-section-card:nth-child(1) { animation-delay: 0.1s; }
.legal-section-card:nth-child(2) { animation-delay: 0.2s; }
.legal-section-card:nth-child(3) { animation-delay: 0.3s; }
.legal-section-card:nth-child(4) { animation-delay: 0.4s; }
.legal-section-card:nth-child(5) { animation-delay: 0.5s; }
</style>